import React, { useEffect, useState } from 'react';
 
import {
 
  DataGrid,
 
  GridToolbarContainer,
 
  gridPageCountSelector,
 
  gridPageSelector,
 
  useGridApiContext,
 
  useGridSelector,
 
} from '@mui/x-data-grid';
 
import Pagination from '@mui/material/Pagination';
 
import { downloadErrorReport } from "../../API/costReportFileApi";
 
import { localDatabaseUrls } from "../../backend/constants";
 
import classess from '../../templates/CostUpload/CostUpload.module.css';
 
import { Button, Tooltip, TextField } from "@mui/material";
 
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
 
import { format } from 'date-fns';
 
// ====== Constants & Helpers moved OUTSIDE ======
 
export const errorStatus = "Processed with errors";
 
// Files in Uploaded status are still in the user-input bucket and are downloadable.
// Only suppress the link while the file is actively being moved/processed.
export const originalStatus = ["In progress"];
 
export function rowProcess(validRows, totalRows) {
 
  return totalRows !== null && validRows !== null ? validRows + '/' + totalRows : '0/0';
 
}
 
export const handleDownload = async (fileId, fileName, downloadFile) => {
 
  try {
 
    await downloadErrorReport(fileId, fileName, downloadFile);
 
  } catch (error) {
 
    console.error('Error downloading the file:', error);
 
  }
 
};
 
export const CustomDateFilterInput = ({ item, applyValue }) => {
 
  const [selectedDate, setSelectedDate] = useState(item.value ? new Date(item.value) : null);
 
  const handleChange = (newDate) => {
 
    const formattedDate = newDate ? format(newDate, 'yyyy-MM-dd') : null;
 
    setSelectedDate(newDate);
 
    applyValue({ ...item, value: formattedDate });
 
  };
 
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
 
        label="Select Date"
 
        value={selectedDate}
 
        onChange={(newDate) => handleChange(newDate)}
 
        views={['year', 'month', 'day']}
 
        renderInput={(params) => <TextField {...params} fullWidth />}
 
      />
    </LocalizationProvider>
 
  );
 
};
 
// ====== Columns moved OUTSIDE ======
 
export const columns = [
 
  {
 
    field: 'fileName',
 
    flex: 1,
 
    headerName: 'File Name',
 
    sortable: true,
 
    filterable: true,
 
    width: 200,
 
    renderCell: (params) => {
 
      return originalStatus.includes(params.row.status) ? (
 
        params.row.fileName
 
      ) : (
        <Tooltip
 
          title={params.row.fileName}
 
          PopperProps={{
 
            modifiers: [{ name: 'offset', options: { offset: [0, 0] } }],
 
          }}
        >
          <Button
 
            style={{
 
              overflow: 'hidden',
 
              whiteSpace: 'nowrap',
 
              maxWidth: '150px',
 
              textOverflow: 'ellipsis',
 
              display: 'inline-block',
 
            }}
 
            onClick={() =>
 
              handleDownload(
 
                params.row.id,
 
                params.row.fileName,
 
                localDatabaseUrls.serviceURL.originalFilePrefix
 
              )
 
            }
          >
 
            {params.row.fileName}
          </Button>
        </Tooltip>
 
      );
 
    },
 
  },
 
  { field: 'uploadedBy', flex: 1, headerName: 'Uploaded By', sortable: true, filterable: true, width: 200 },
 
  {
 
    field: 'uploadedDate',
 
    flex: 1,
 
    headerName: 'Uploaded Date',
 
    sortable: true,
 
    filterable: true,
 
    width: 200,
 
    filterOperators: [
 
      {
 
        label: 'is',
 
        value: 'is',
 
        getApplyFilterFn: (filterItem) => {
 
          if (!filterItem.columnField || !filterItem.value) return null;
 
          const filterDate = new Date(filterItem.value);
 
          return ({ value }) => {
 
            const cellDate = new Date(value);
 
            return (
 
              cellDate.getFullYear() === filterDate.getFullYear() &&
 
              cellDate.getMonth() === filterDate.getMonth() &&
 
              cellDate.getDate() === filterDate.getDate()
 
            );
 
          };
 
        },
 
        InputComponent: CustomDateFilterInput,
 
      },
 
      {
 
        label: 'is after',
 
        value: 'is after',
 
        getApplyFilterFn: (filterItem) => {
 
          if (!filterItem.columnField || !filterItem.value) return null;
 
          return ({ value }) => new Date(value) > new Date(filterItem.value);
 
        },
 
        InputComponent: CustomDateFilterInput,
 
      },
 
      {
 
        label: 'is before',
 
        value: 'is before',
 
        getApplyFilterFn: (filterItem) => {
 
          if (!filterItem.columnField || !filterItem.value) return null;
 
          return ({ value }) => new Date(value) < new Date(filterItem.value);
 
        },
 
        InputComponent: CustomDateFilterInput,
 
      },
 
    ],
 
  },
 
  { field: 'category', flex: 1, headerName: 'Category', sortable: true, filterable: true, width: 200 },
 
  { 
    field: 'costType', 
    flex: 1, 
    headerName: 'APG/ASG', 
    sortable: true, 
    filterable: true, 
    width: 200 ,
  },
 
  { field: 'status', flex: 1, headerName: 'Status', sortable: true, filterable: true, width: 200 },
 
  {
 
    field: 'rows',
 
    flex: 1,
 
    headerName: 'Rows (Valid/Total)',
 
    sortable: true,
 
    filterable: true,
 
    width: 200,
 
    valueGetter: (params) => rowProcess(params.row.validRows, params.row.totalRows),
 
  },
 
  {
 
    field: 'download',
 
    flex: 1,
 
    headerName: 'Download error report',
 
    sortable: true,
 
    disableColumnMenu: true,
 
    width: 200,
 
    renderCell: (params) =>
 
      params.row.status === errorStatus && (
        <Button
 
          name="download"
 
          className={classess.uploadBtn}
 
          onClick={() =>
 
            handleDownload(
 
              params.row.id,
 
              params.row.fileName,
 
              localDatabaseUrls.serviceURL.errorReportFilePrefix
 
            )
 
          }
        >
 
          Download
        </Button>
 
      ),
 
  },
 
];
 
const CostUploadHistoryTable = ({ uploadHistory, isPaginationRequired }) => {
 
  const [gridData, setGridData] = useState(uploadHistory);
  const [loading, setLoading] = useState(true);
 
 useEffect(() => {
 
        if (uploadHistory) {
            const rows = uploadHistory.map((item) => ({
                ...item,
                download: item.status === errorStatus ? 'y' : 'n'
            }));
            setGridData(rows);
            setLoading(false);
        }
    }, [uploadHistory])
 
 
  const handleReset = () => {
 
    window.location.reload();
 
  };
 
  const CustomToolbar = () => (
    <GridToolbarContainer>
      <Button
 
        variant="contained"
 
        style={{ marginLeft: 'auto', backgroundColor: 'darkblue' }}
 
        onClick={handleReset}
      >
 
        Reset
      </Button>
    </GridToolbarContainer>
 
  );
 
  function CustomPagination() {
 
    const apiRef = useGridApiContext();
 
    const page = useGridSelector(apiRef, gridPageSelector);
 
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
 
    return isPaginationRequired ? (
      <Pagination
 
        color="primary"
 
        count={pageCount}
 
        page={page + 1}
 
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
 
      />
 
    ) : null;
 
  }
 
  return (
    <div style={{ height: 'calc(100vh - 200px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, overflow: 'auto' }}>
        <DataGrid
 
          components={{
 
            Toolbar: CustomToolbar,
 
            Pagination: CustomPagination,
 
          }}
 
          rows={gridData}
 
          columns={columns}
 
          disableRowSelectionOnClick
 
          pagination
 
          pageSize={10}
 
          autoHeight={false}
 
          loading={loading}
 
          sortingMode="client"
 
          filterMode="client"
 
          sx={{
 
            '& .MuiDataGrid-columnHeaderTitle': {
 
              fontWeight: 'bold',
 
            },
 
            '& .MuiDataGrid-toolbarcontainer': {
 
              display: 'flex',
 
              justifyContent: 'space-between',
 
            },
 
            '& .MuiDataGrid-cellContent': {
 
              whiteSpace: 'nowrap',
 
              overflow: 'hidden',
 
              textOverflow: 'ellipsis',
 
            },
 
          }}
 
        />
      </div>
    </div>
 
  );
 
};
 
export default CostUploadHistoryTable;
 
